import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import clinicAPI from "../../../services/clinicApi";
import ClubLifePostCard from "./ClubLifePostCard";
import ClubLifeComposer from "../PatientPortal/ClubLifeComposer";
import { useClubLifeInteractions } from "../../../hooks/useClubLifeInteractions";
import cs from "../PatientPortal/clientApp.module.css";
import aa from "../AdminPortal/adminApp.module.css";
import md from "./manageDesktop.module.css";

export default function ClubLifeHomeSection({
  title = "Жизнь клуба",
  feedLink,
  feedLabel = "Лента",
  limit = null,
  mode = "admin",
  appMode = false,
  showComposer = true,
  desktop = false,
}) {
  const isAdmin = mode === "admin";
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const {
    commentBusy,
    openComments,
    commentsByPost,
    toggleLike,
    loadComments,
    addComment,
  } = useClubLifeInteractions(setPosts, {
    commentsApi: isAdmin ? "admin" : "client",
  });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = limit != null ? { limit: Math.max(limit, 3) } : {};
      const data = isAdmin
        ? await clinicAPI.getClubLifePosts(params)
        : await clinicAPI.getClubLifeFeed(params);
      const rows = data.posts || [];
      setPosts(limit != null ? rows.slice(0, limit) : rows);
    } catch {
      setPosts([]);
    } finally {
      setLoading(false);
    }
  }, [isAdmin, limit]);

  useEffect(() => {
    load();
  }, [load]);

  if (!showComposer && !feedLink && !loading && posts.length === 0) {
    return null;
  }

  const cardMode = isAdmin ? "admin" : "client";
  const sectionClass = [
    desktop ? md.desktopClubLife : cs.homeSection,
    desktop ? null : cs.homeCard,
    appMode ? aa.clubLifeHomeBlock : "",
  ]
    .filter(Boolean)
    .join(" ");

  if (desktop) {
    return (
      <section className={sectionClass} aria-label={title}>
        <div className={md.desktopClubLifeHead}>
          <h2 className={md.desktopClubLifeTitle}>{title}</h2>
          {feedLink ? (
            <Link to={feedLink} className={md.desktopClubLifeLink}>
              {feedLabel}
            </Link>
          ) : null}
        </div>

        {showComposer ? (
          <div className={md.desktopClubLifeComposer}>
            <ClubLifeComposer
              compact
              embedded
              variant={isAdmin ? "admin" : "client"}
              onPublished={load}
            />
          </div>
        ) : null}

        {!loading && posts.length > 0 ? (
          <div className={md.desktopClubLifeFeed}>
            {posts.map((post) => (
              <ClubLifePostCard
                key={post.id}
                post={post}
                mode={cardMode}
                onLike={toggleLike}
                onLoadComments={loadComments}
                commentsOpen={openComments === post.id}
                comments={commentsByPost[post.id] || []}
                onComment={addComment}
                commentBusy={commentBusy}
              />
            ))}
          </div>
        ) : null}
      </section>
    );
  }

  return (
    <section className={sectionClass} aria-label={title}>
      <div className={cs.homeCardHead}>
        <h2 className={cs.homeSectionTitle}>{title}</h2>
        {feedLink ? (
          <Link to={feedLink} className={cs.homeSectionLink}>
            {feedLabel}
          </Link>
        ) : null}
      </div>

      {showComposer ? (
        <div className={cs.homeComposerWrap}>
          <ClubLifeComposer
            compact
            embedded
            variant={isAdmin ? "admin" : "client"}
            onPublished={load}
          />
        </div>
      ) : null}

      {!loading && posts.length > 0 ? (
        <div className={cs.homeFeed}>
          {posts.map((post) => (
            <ClubLifePostCard
              key={post.id}
              post={post}
              mode={cardMode}
              onLike={toggleLike}
              onLoadComments={loadComments}
              commentsOpen={openComments === post.id}
              comments={commentsByPost[post.id] || []}
              onComment={addComment}
              commentBusy={commentBusy}
            />
          ))}
        </div>
      ) : null}
    </section>
  );
}
